import { Box, Divider, Stack } from "@mui/material";
import React from "react";
import CSkeleton from "../../CSkeleton/CSkeleton";
import CopyText from "../../CopyText/CopyText";
import { Bank } from "../../../Models/Banks";
import useAuthState from "../../../Utils/store";
import { getRemoteValue } from "../../../Utils/firebase";

interface Props {
  bank: Bank | undefined;
  refCode: string | undefined;
}
const BankInfosForEft = ({ bank, refCode }: Props) => {
  const logoSrc =
    bank?.name === "Akbank"
      ? "/akbank-logo.png"
      : bank?.name === "Fibabanka"
      ? "/fibabank-logo.png"
      : "";

  return (
    <Box
      key={"bank"}
      display={"flex"}
      flexDirection={"column"}
      p={2}
      mt={2}
      gap={2}
      sx={{ borderRadius: "12px", border: " 2px solid #F1F5F9" }}
    >
      <Stack
        className="!flex-col ml:!flex-row gap-[8px] ml:gap-[0px]"
        justifyContent={"space-between"}
      >
        <div className="text-sm font-normal text-cardLabel">
          <Box
            component="img"
            src={logoSrc}
            sx={{
              width: 106,
              height: 25,
            }}
          />
        </div>
      </Stack>
      <Stack
        className="!flex-col ml:!flex-row gap-[8px] ml:gap-[0px]"
        justifyContent={"space-between"}
      >
        <div className="text-sm font-normal text-cardLabel">
          {getRemoteValue("bank_name")}
        </div>
        <div className="text-sm font-medium	 text-[#191B1E]">{bank?.name}</div>
      </Stack>
      <Divider className="ml:hidden" sx={{ borderColor: "#E2E8F0" }} />
      <Stack
        className="!flex-col ml:!flex-row gap-[8px] ml:gap-[0px]"
        justifyContent={"space-between"}
      >
        <div className="text-sm font-normal text-cardLabel">
          {getRemoteValue("iban_no")}
        </div>
        <div className="text-sm font-semibold text-cardValue">
          <CopyText text={bank?.iban} />
        </div>
      </Stack>
      <Divider className="ml:hidden" sx={{ borderColor: "#E2E8F0" }} />
      <Stack
        className="!flex-col ml:!flex-row gap-[8px] ml:gap-[0px]"
        justifyContent={"space-between"}
      >
        <div className="text-sm font-normal text-cardLabel">
          {getRemoteValue("recipient_name")}
        </div>
        <div className="text-sm font-semibold text-cardValue">
          <CopyText text={bank?.receiverName} />
        </div>
      </Stack>
      <Divider className="ml:hidden" sx={{ borderColor: "#E2E8F0" }} />
      <Stack
        className="!flex-col ml:!flex-row gap-[8px] ml:gap-[0px]"
        justifyContent={"space-between"}
      >
        <div className="text-sm font-norma text-cardLabel flex">
          {getRemoteValue("reference_code")}
          <div className="text-[#8292A5] ml-1">
            {getRemoteValue("desciription_field_info")}
          </div>
        </div>
        <div className="text-sm font-semibold text-cardValue">
          {refCode && <CopyText text={refCode} />}
        </div>
      </Stack>
    </Box>
  );
};

export default BankInfosForEft;
